import { createRoute, useNavigate } from '@tanstack/solid-router'
import { appLayoutRoute } from '../app-layout.route'
import { Dashboard } from '../../Dashboard'
import { viewNavigate } from '../links'

export const indexRoute = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/',
  component: IndexRouteComponent,
})

function IndexRouteComponent() {
  const navigate = useNavigate()
  return (
    <Dashboard
      onOpenWell={() => navigate({ to: '/wells', search: {} })}
      onOpenView={(v) => navigate(viewNavigate(v))}
    />
  )
}
